import { createApi } from '@reduxjs/toolkit/query/react';
import customBaseQuery from '@/lib/customBaseQuery';

const locationsBaseUrl = '/api/locations';

export const locationsApi = createApi({
  reducerPath: 'locationsApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    locationsById: builder.query<LocationsResponse, number>({
      query: (id) => ({
        url: `${locationsBaseUrl}/${id}`,
      }),
    }),
  }),
});

export const { useLocationsByIdQuery } = locationsApi;
